import axios from "axios";
import { getToken } from "../helper/tokenHelper";

// const baseUrl = "http://localhost:4000/api/v1";
// const baseUrl = "https://jonny-backend.vercel.app/api/v1";
//
//prod
// const baseUrl = "https://backend-zeta-five-21.vercel.app/api/v1";
//sit
// const baseUrl = "https://jonny-revamped-backend.vercel.app/api/v1";
const baseUrl = "https://backend-v2-kappa.vercel.app/api/v1";

export const axiosApi = async (method, url, data = {}, options = {}) => {
  const allowedMethods = ["GET", "POST", "PATCH", "DELETE", "PUT"];
  method = method.toUpperCase();

  const methodFound = allowedMethods.find(
    (allowedMethod) => allowedMethod === method
  );
  if (!methodFound) {
    throw "Invalid format";
  }

  let reqConfig = {
    url: `${baseUrl}${url}`,
    method,
    params: options.params,
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  };
  if (method === "POST" || method === "PUT" || method === "DELETE") {
    reqConfig["data"] = data;
  }
  return axios(reqConfig)
    .then((resp) => resp?.data)
    .catch((err) => {
      return Promise.reject(err);
    })
    .catch((err) => {
      if (err?.response?.status === 401) {
        console.log("unauthorized");
      }
      return Promise.reject(err?.response?.data?.message);
    });
};
